/** オーディオアセットのキー定数 */
export const AudioKey = {
  BGM_TITLE: 'bgm_title',
  BGM_CHARACTER_SELECT: 'bgm_character_select',
  BGM_BATTLE: 'bgm_battle',
  BGM_TOURNAMENT: 'bgm_tournament',
  BGM_SURVIVAL_1: 'bgm_survival_1',
  BGM_SURVIVAL_2: 'bgm_survival_2',
  BGM_SURVIVAL_3: 'bgm_survival_3',
  BGM_RESULT_VICTORY: 'bgm_result_victory',
  BGM_RESULT_DEFEAT: 'bgm_result_defeat',
  BGM_BOSS: 'bgm_boss',
  SE_WEAPON_ATTACK: 'se_weapon_attack',
  SE_SPECIAL_ATTACK: 'se_special_attack',
  SE_DODGE: 'se_dodge',
  SE_MOVE: 'se_move',
  SE_REFLECT: 'se_reflect',
  SE_REFLECT_BLOCK: 'se_reflect_block',
  SE_SELECT: 'se_select',
  SE_VICTORY: 'se_victory',
  SE_DEFEAT: 'se_defeat',
} as const;

/** AudioKeyの値の型 */
export type AudioKeyValue = (typeof AudioKey)[keyof typeof AudioKey];

/** BGMキーの一覧 */
export const BGM_KEYS: readonly AudioKeyValue[] = [
  AudioKey.BGM_TITLE,
  AudioKey.BGM_CHARACTER_SELECT,
  AudioKey.BGM_BATTLE,
  AudioKey.BGM_TOURNAMENT,
  AudioKey.BGM_SURVIVAL_1,
  AudioKey.BGM_SURVIVAL_2,
  AudioKey.BGM_SURVIVAL_3,
  AudioKey.BGM_RESULT_VICTORY,
  AudioKey.BGM_RESULT_DEFEAT,
  AudioKey.BGM_BOSS,
];

/** SEキーの一覧 */
export const SE_KEYS: readonly AudioKeyValue[] = [
  AudioKey.SE_WEAPON_ATTACK,
  AudioKey.SE_SPECIAL_ATTACK,
  AudioKey.SE_DODGE,
  AudioKey.SE_MOVE,
  AudioKey.SE_REFLECT,
  AudioKey.SE_REFLECT_BLOCK,
  AudioKey.SE_SELECT,
  AudioKey.SE_VICTORY,
  AudioKey.SE_DEFEAT,
];

/** 全AudioKeyの値セット */
const ALL_AUDIO_KEYS = new Set<string>(Object.values(AudioKey));

/** 文字列がAudioKeyの値かどうかを判定する型ガード */
export function isAudioKey(value: string): value is AudioKeyValue {
  return ALL_AUDIO_KEYS.has(value);
}
